/**
 * El menú que sale al soltar una cita en el mes: misma hora, o el panel de huecos.
 */
import { useEffect, useRef } from 'react'

export function MenuSoltarMes({
    x,
    y,
    alMismaHora,
    alCambiarHora,
    alCerrar,
}: {
    x: number
    y: number
    alMismaHora: () => void
    alCambiarHora: () => void
    alCerrar: () => void
}) {
    const caja = useRef<HTMLDivElement>(null)

    useEffect(() => {
        function fuera(e: MouseEvent) {
            if (caja.current && !caja.current.contains(e.target as Node)) alCerrar()
        }
        function tecla(e: KeyboardEvent) {
            if (e.key === 'Escape') alCerrar()
        }
        document.addEventListener('mousedown', fuera)
        document.addEventListener('keydown', tecla)
        return () => {
            document.removeEventListener('mousedown', fuera)
            document.removeEventListener('keydown', tecla)
        }
    }, [alCerrar])

    const left = Math.min(x, window.innerWidth - 220)
    const top = Math.min(y, window.innerHeight - 140)

    return (
        <div
            ref={caja}
            role="menu"
            data-testid="menu-soltar-mes"
            className="fixed z-50 w-56 overflow-hidden rounded-lg border border-neutral-700 bg-neutral-900 py-1 shadow-xl shadow-black/50"
            style={{ left, top }}
        >
            <button
                type="button"
                role="menuitem"
                onClick={alMismaHora}
                className="block w-full px-3 py-2 text-left text-sm text-neutral-100 hover:bg-neutral-800"
            >
                Mover a la misma hora
            </button>
            <button
                type="button"
                role="menuitem"
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                    e.stopPropagation()
                    alCambiarHora()
                }}
                className="block w-full px-3 py-2 text-left text-sm text-neutral-100 hover:bg-neutral-800"
            >
                Mover y cambiar de hora
            </button>
        </div>
    )
}
